(function () {
  "use strict";

  mfSocialShare.$inject = ['$parse'];
  angular
    .module('trainerWebApp.directives')
    .directive('mfSocialShare', mfSocialShare);

  function mfSocialShare($parse) {
    return {
      restrict: 'A',
      link: function (scope, iElement, iAttrs) {
        var shareFunction = $parse(iAttrs['mfSocialShare']);
        var shareType = iAttrs['mfSocialShareType'] || "series";    // series, catalog

        var scopeShareFunction = function (args) {
          scope.$apply(function () {
            shareFunction(scope, {$shareEvent: args});
          });
        };

        var elem = iElement;

        var clickEventHandler = function (event) {
          var shareEvent = {
            type: '',
            url: '',
            title: '',
            description: '',
            companyName: '',
            trainerName: '',
            objectId: 0,
            companyLogoURL: '',
            mindflashLogoURL: '',
            yammerUrl: ''
          };

          scopeShareFunction.apply(elem, [shareEvent]);

          switch (shareEvent.type) {
            case 'email':
              shareToEmail(shareEvent);
              break;
            case 'facebook':
              shareToFacebook(shareEvent);
              break;
            case 'linkedin':
              shareToLinkedIn(shareEvent);
              break;
            case 'twitter':
              shareToTwitter(shareEvent);
              break;
            case 'yammer':
              shareToYammer(shareEvent);
              break;
          }
        };

        function shareToYammer(shareEvent) {
          MF.YammerConfig = MF.YammerConfig || {
            url: shareEvent.yammerUrl + "/"
          };
          MF.YammerHelper.authenticateForStatus("Here is a link to take my " + shareType + ". ", shareEvent.url);
        }

        function shareToEmail(shareEvent) {
          MF.SocialAPI.shareByEmail(shareEvent.url, shareEvent.title, shareEvent.description, shareEvent.companyName, shareEvent.trainerName, shareType);
        }

        function shareToFacebook(shareEvent) {
          MF.SocialAPI.shareToFacebook(shareEvent.url, shareEvent.title, shareEvent.description, shareEvent.mindflashLogoURL, shareEvent.companyLogoURL);
        }

        function shareToLinkedIn(shareEvent) {
          MF.SocialAPI.shareToLinkedIn(shareEvent.url, shareEvent.title);
        }

        function shareToTwitter(shareEvent) {
          MF.SocialAPI.shareToTwitter(shareEvent.objectId, buildTwitterText(shareEvent));
        }

        function buildTwitterText(shareEvent) {
          var maxAllowedLength = 120;
          var longText = "Check out this great online " + shareType + ".\"" + shareEvent.title + "\" by " + shareEvent.companyName + ", powered by @mindflash ";

          if (longText.length <= maxAllowedLength) {
            return longText + shareEvent.url;
          }

          var shortText = "Check out this great online " + shareType + ".\"" + shareEvent.title + "\", powered by @mindflash ";

          if (shortText.length > maxAllowedLength) {
            var truncateLength = shareEvent.title.length - (shortText.length - maxAllowedLength);

            return "Check out this great online " + shareType + ". \"" + MF.TextHelper.truncateText(shareEvent.title, truncateLength) + "\", powered by @mindflash " + shareEvent.url;
          }
          return shortText + shareEvent.url;
        }

        iElement.bind('click', clickEventHandler);

        scope.$on('$destroy', function () {
          iElement.unbind('click', clickEventHandler);
        });
      }
    }
  }

})();
